const ALLOWED_HOSTNAMES: Record<string, string> = {
  'tiktok.com': 'TikTok',
  'www.tiktok.com': 'TikTok',
  'vm.tiktok.com': 'TikTok',
  'vt.tiktok.com': 'TikTok',
  'instagram.com': 'Instagram',
  'www.instagram.com': 'Instagram',
  'youtube.com': 'YouTube',
  'www.youtube.com': 'YouTube',
  'm.youtube.com': 'YouTube',
  'music.youtube.com': 'YouTube',
  'youtube-nocookie.com': 'YouTube',
  'www.youtube-nocookie.com': 'YouTube',
  'youtu.be': 'YouTube',
}

export type SocialMediaValidationResult =
  | { valid: true; platform: string }
  | { valid: false; reason: 'invalid_url' | 'unsupported_platform' }

export function validateSocialMediaUrl(url: string): SocialMediaValidationResult {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return { valid: false, reason: 'invalid_url' }
  }

  const platform = ALLOWED_HOSTNAMES[parsed.hostname.toLowerCase()]
  if (!platform) {
    return { valid: false, reason: 'unsupported_platform' }
  }

  return { valid: true, platform }
}

export const SUPPORTED_PLATFORMS = ['TikTok', 'Instagram', 'YouTube']
